import React, { useEffect, useState } from 'react';
import { Search, Menu, X, Moon, Sun, Hammer } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { AGREEXA_APP_URL } from '../lib/links';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDark, setIsDark] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);
  const navLinks = ['Projects', 'AI Generator', 'Community', 'Tools', 'Marketplace'];
  return <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'glass py-4' : 'bg-transparent py-6'}`} data-id="element-248">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-249">
        <div className="flex items-center gap-2" data-id="element-250">
          <div className="w-10 h-10 rounded-xl bg-orange-500 flex items-center justify-center text-white" data-id="element-251">
            <Hammer size={24} data-id="element-252" />
          </div>
          <span className="text-2xl font-bold tracking-tight text-navy-900 dark:text-white" data-id="element-253">
            Agreexa
          </span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-254">
          <div className="flex items-center gap-6" data-id="element-255">
            {navLinks.map(link => <a key={link} href={AGREEXA_APP_URL} className="text-sm font-medium text-navy-800 dark:text-gray-300 hover:text-orange-500 dark:hover:text-orange-400 transition-colors" data-id="element-256">
                {link}
              </a>)}
          </div>

          <div className="flex items-center gap-4" data-id="element-257">
            <button className="p-2 rounded-full hover:bg-navy-100 dark:hover:bg-navy-800 transition-colors text-navy-800 dark:text-gray-300" data-id="element-258">
              <Search size={20} data-id="element-259" />
            </button>
            <button onClick={() => setIsDark(!isDark)} className="p-2 rounded-full hover:bg-navy-100 dark:hover:bg-navy-800 transition-colors text-navy-800 dark:text-gray-300" data-id="element-260">
              {isDark ? <Sun size={20} data-id="element-261" /> : <Moon size={20} data-id="element-262" />}
            </button>
            <a href={AGREEXA_APP_URL} className="px-5 py-2.5 rounded-full bg-navy-900 dark:bg-white text-white dark:text-navy-900 text-sm font-semibold hover:bg-navy-800 dark:hover:bg-gray-100 transition-colors" data-id="element-263">
              Sign In
            </a>
          </div>
        </div>

        {/* Mobile Toggle */}
        <div className="md:hidden flex items-center gap-4" data-id="element-264">
          <button onClick={() => setIsDark(!isDark)} className="p-2 rounded-full text-navy-800 dark:text-gray-300" data-id="element-265">
            {isDark ? <Sun size={20} data-id="element-266" /> : <Moon size={20} data-id="element-267" />}
          </button>
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-navy-800 dark:text-gray-300" data-id="element-268">
            {isMobileMenuOpen ? <X size={24} data-id="element-269" /> : <Menu size={24} data-id="element-270" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-271">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 w-full glass-card border-t-0 p-6 flex flex-col gap-4 md:hidden" data-id="element-272">
            {navLinks.map(link => <a key={link} href={AGREEXA_APP_URL} className="text-lg font-medium text-navy-800 dark:text-gray-300" data-id="element-273">
                {link}
              </a>)}
            <div className="h-px bg-gray-200 dark:bg-navy-700 my-2" data-id="element-274" />
            <a href={AGREEXA_APP_URL} className="w-full py-3 rounded-xl bg-orange-500 text-white font-semibold text-center block" data-id="element-275">
              Sign In
            </a>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}